import React from 'react'
import { observer } from 'mobx-react'
import FirmDashboardJobsViewModel from '../FirmDashboardJobsViewer/FirmDashboardJobTableViewModel'
import { useToggle } from 'hooks/state-hooks'
import FirmDashboardPrimaryControls from './FirmDashboardPrimaryControls'
import FilterControls from 'infra/FilterControls'

interface FirmDashboardJobsViewerHeaderProps {
  vm: FirmDashboardJobsViewModel
}

export default observer(function FirmDashboardJobsViewerHeader({
  vm,
}: FirmDashboardJobsViewerHeaderProps) {
  const hasFilters = vm.searcher.filters.appliedFilterCount > 0
  const showingFilterControls = useToggle(hasFilters)

  return (
    <div>
      <FirmDashboardPrimaryControls
        vm={vm}
        onChange={vm.searcher.searchText.change}
        onShowFilterControlsClick={showingFilterControls.toggle}
        filterCount={vm.searcher.filters.appliedFilterCount}
        value={vm.searcher.searchText.value}
      />
      <FilterControls
        active={showingFilterControls.isEnabled}
        vm={vm.searcher.filters}
      />
    </div>
  )
})
